function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "variant", "size", "onClick", "style", "type", "as", "href"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* global React, window */
// ============================================================================
// UI primitives — Button, Pill, Icon, Tag, Eyebrow, Marquee, SectionHead.
// Sleek editorial e-commerce vocabulary. Hairline rules, restrained accent.
// ============================================================================
var _React = React,
  useStateUI = _React.useState,
  useEffectUI = _React.useEffect,
  useRefUI = _React.useRef;

// ---- Button ---------------------------------------------------------------
function Button(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "primary" : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    onClick = _ref.onClick,
    style = _ref.style,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "button" : _ref$type,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? "button" : _ref$as,
    href = _ref.href,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStateUI = useStateUI(false),
    _useStateUI2 = _slicedToArray(_useStateUI, 2),
    hover = _useStateUI2[0],
    setHover = _useStateUI2[1];
  var SIZE = {
    sm: {
      padding: "10px 16px",
      fontSize: 12,
      gap: 8
    },
    md: {
      padding: "14px 22px",
      fontSize: 13,
      gap: 10
    },
    lg: {
      padding: "18px 28px",
      fontSize: 14,
      gap: 12
    }
  }[size];
  var styles = {
    primary: {
      bg: hover ? "transparent" : "var(--ink)",
      fg: hover ? "var(--ink)" : "var(--bone)",
      bd: "var(--ink)"
    },
    secondary: {
      bg: hover ? "var(--ink)" : "transparent",
      fg: hover ? "var(--bone)" : "var(--ink)",
      bd: "var(--ink)"
    },
    quiet: {
      bg: "transparent",
      fg: hover ? "var(--ink)" : "var(--muted)",
      bd: "transparent"
    },
    rust: {
      bg: hover ? "var(--rust-2)" : "var(--rust)",
      fg: "#fff",
      bd: hover ? "var(--rust-2)" : "var(--rust)"
    },
    link: {
      bg: "transparent",
      fg: "var(--ink)",
      bd: "transparent",
      underline: true
    },
    invert: {
      bg: hover ? "transparent" : "var(--bone)",
      fg: hover ? "var(--bone)" : "var(--ink)",
      bd: "var(--bone)"
    }
  }[variant] || {};
  var C = as === "a" ? "a" : "button";
  return /*#__PURE__*/React.createElement(C, _extends({
    type: as === "button" ? type : undefined,
    href: as === "a" ? href || "#" : undefined,
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: _objectSpread({
      display: "inline-flex",
      alignItems: "center",
      gap: SIZE.gap,
      padding: variant === "link" || variant === "quiet" ? "".concat(parseInt(SIZE.padding) / 2, "px 0") : SIZE.padding,
      border: "1px solid ".concat(styles.bd),
      background: styles.bg,
      color: styles.fg,
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: SIZE.fontSize,
      letterSpacing: "0.03em",
      cursor: "pointer",
      transition: "background var(--dur) var(--ease), color var(--dur) var(--ease), border-color var(--dur) var(--ease), transform 80ms var(--ease)",
      borderRadius: 0,
      whiteSpace: "nowrap",
      textDecoration: styles.underline && hover ? "underline" : "none",
      textUnderlineOffset: 6
    }, style)
  }, rest), children);
}

// ---- Pill / Tag -----------------------------------------------------------
function Pill(_ref2) {
  var children = _ref2.children,
    _ref2$tone = _ref2.tone,
    tone = _ref2$tone === void 0 ? "neutral" : _ref2$tone,
    style = _ref2.style;
  var tones = {
    neutral: {
      bg: "transparent",
      fg: "var(--ink)",
      bd: "var(--line-2)"
    },
    rust: {
      bg: "var(--rust-50)",
      fg: "var(--rust)",
      bd: "transparent"
    },
    forest: {
      bg: "rgba(44,58,46,0.08)",
      fg: "var(--forest)",
      bd: "transparent"
    },
    ink: {
      bg: "var(--ink)",
      fg: "var(--bone)",
      bd: "var(--ink)"
    },
    bone: {
      bg: "var(--bone)",
      fg: "var(--ink)",
      bd: "var(--line-2)"
    }
  }[tone] || {};
  return /*#__PURE__*/React.createElement("span", {
    style: _objectSpread({
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "5px 10px",
      background: tones.bg,
      color: tones.fg,
      border: "1px solid ".concat(tones.bd),
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 11,
      letterSpacing: "0.12em",
      textTransform: "uppercase"
    }, style)
  }, children);
}

// ---- Eyebrow --------------------------------------------------------------
function Eyebrow(_ref3) {
  var children = _ref3.children,
    _ref3$tone = _ref3.tone,
    tone = _ref3$tone === void 0 ? "muted" : _ref3$tone,
    style = _ref3.style;
  var color = tone === "rust" ? "var(--rust)" : tone === "ink" ? "var(--ink)" : "var(--muted)";
  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 11,
      letterSpacing: "0.18em",
      textTransform: "uppercase",
      color: color
    }, style)
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-block",
      width: 24,
      height: 1,
      background: color
    }
  }), /*#__PURE__*/React.createElement("span", null, children));
}

// ---- Icon (filled SVG, single weight, 20 default) -------------------------
function Icon(_ref4) {
  var name = _ref4.name,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 20 : _ref4$size,
    _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? "currentColor" : _ref4$color,
    _ref4$strokeWidth = _ref4.strokeWidth,
    strokeWidth = _ref4$strokeWidth === void 0 ? 1.5 : _ref4$strokeWidth,
    style = _ref4.style;
  var s = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: style
  };
  var I = {
    search: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("circle", {
      cx: "11",
      cy: "11",
      r: "7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16l5 5"
    })),
    user: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "8",
      r: "4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 21c1-5 5-7 8-7s7 2 8 7"
    })),
    cart: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M4 5h2.5l2 12.5h11L21 8H7"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "9",
      cy: "20",
      r: "1.5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "18",
      cy: "20",
      r: "1.5"
    })),
    bag: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M5 8h14l-1 13H6L5 8z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 8a3 3 0 016 0"
    })),
    menu: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M3 7h18M3 17h18"
    })),
    close: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M5 5l14 14M19 5L5 19"
    })),
    arrowR: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M5 12h14M13 5l7 7-7 7"
    })),
    arrowL: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M19 12H5M11 5l-7 7 7 7"
    })),
    arrowDR: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M7 17L17 7M9 7h8v8"
    })),
    arrowDown: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M12 5v14M5 13l7 7 7-7"
    })),
    plus: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M12 5v14M5 12h14"
    })),
    minus: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M5 12h14"
    })),
    heart: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M12 21s-7-4.5-9-9C2 8 4 5 7 5c2 0 4 1 5 3 1-2 3-3 5-3 3 0 5 3 4 7-2 4.5-9 9-9 9z"
    })),
    star: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M12 3l3 6.5 7 1-5 5 1.2 7L12 19l-6.2 3.5L7 15.5l-5-5 7-1L12 3z"
    })),
    pin: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M12 21c-5-6-7-9-7-12a7 7 0 0114 0c0 3-2 6-7 12z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "9",
      r: "2.5"
    })),
    clock: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v5l3 2"
    })),
    truck: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("rect", {
      x: "2",
      y: "7",
      width: "12",
      height: "9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10h4l3 3v3h-7"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "6",
      cy: "18",
      r: "2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "17",
      cy: "18",
      r: "2"
    })),
    leaf: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M5 19c0-8 6-14 14-14 0 8-6 14-14 14z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19l10-10"
    })),
    package: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M3 7l9-4 9 4-9 4-9-4z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7v10l9 4 9-4V7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 11v10"
    })),
    sparkle: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M12 3l1.5 5.5L19 10l-5.5 1.5L12 17l-1.5-5.5L5 10l5.5-1.5L12 3z"
    })),
    eye: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "3"
    })),
    grid: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("rect", {
      x: "3",
      y: "3",
      width: "7",
      height: "7"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "14",
      y: "3",
      width: "7",
      height: "7"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "3",
      y: "14",
      width: "7",
      height: "7"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "14",
      y: "14",
      width: "7",
      height: "7"
    })),
    list: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"
    })),
    filter: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M3 5h18l-7 9v6l-4-2v-4L3 5z"
    })),
    instagram: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("rect", {
      x: "3",
      y: "3",
      width: "18",
      height: "18",
      rx: "4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "17.5",
      cy: "6.5",
      r: "0.6",
      fill: color
    })),
    tiktok: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M15 4v9.5a4 4 0 11-4-4M15 4c0 2.5 2 4 4 4"
    })),
    twitter: /*#__PURE__*/React.createElement("svg", s, /*#__PURE__*/React.createElement("path", {
      d: "M4 4l7 9L4 20h2l6-6 4.5 6H20l-7-9 6.5-7h-2L12 9 7.5 4H4z",
      fill: color,
      stroke: "none"
    }))
  };
  return I[name] || null;
}

// ---- Section header -------------------------------------------------------
function SectionHead(_ref5) {
  var eyebrow = _ref5.eyebrow,
    title = _ref5.title,
    lede = _ref5.lede,
    action = _ref5.action,
    _ref5$align = _ref5.align,
    align = _ref5$align === void 0 ? "left" : _ref5$align,
    id = _ref5.id;
  return /*#__PURE__*/React.createElement("header", {
    id: id,
    style: {
      display: "grid",
      gridTemplateColumns: align === "center" ? "1fr" : "1.4fr 1fr",
      alignItems: "end",
      gap: 48,
      paddingBottom: 48,
      textAlign: align
    },
    className: "responsive-2col"
  }, /*#__PURE__*/React.createElement("div", null, eyebrow && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "rust"
  }, eyebrow)), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: "var(--fs-d2)",
      lineHeight: "var(--lh-tight)",
      letterSpacing: "var(--tracking-tight)",
      margin: 0,
      maxWidth: 880,
      color: "var(--ink)",
      textWrap: "balance"
    }
  }, title)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: align === "right" ? "flex-end" : "flex-start",
      gap: 20
    }
  }, lede && /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      maxWidth: 420,
      fontFamily: "var(--font-sans)",
      fontSize: 16,
      lineHeight: 1.6,
      color: "var(--muted)"
    }
  }, lede), action));
}

// ---- Marquee --------------------------------------------------------------
function Marquee(_ref6) {
  var items = _ref6.items,
    _ref6$speed = _ref6.speed,
    speed = _ref6$speed === void 0 ? 40 : _ref6$speed,
    _ref6$dark = _ref6.dark,
    dark = _ref6$dark === void 0 ? false : _ref6$dark,
    _ref6$sep = _ref6.sep,
    sep = _ref6$sep === void 0 ? "—" : _ref6$sep,
    style = _ref6.style;
  var seg = /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 36,
      paddingRight: 36
    }
  }, items.map(function (t, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: i,
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 36
      }
    }, /*#__PURE__*/React.createElement("span", null, t), /*#__PURE__*/React.createElement("span", {
      style: {
        opacity: 0.5,
        fontFamily: "var(--font-serif)",
        fontStyle: "italic"
      }
    }, sep));
  }));
  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({
      background: dark ? "var(--ink)" : "transparent",
      color: dark ? "var(--bone)" : "var(--ink)",
      borderTop: dark ? "none" : "1px solid var(--line)",
      borderBottom: dark ? "none" : "1px solid var(--line)",
      overflow: "hidden",
      padding: "14px 0",
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "0.18em",
      textTransform: "uppercase"
    }, style)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-flex",
      whiteSpace: "nowrap",
      animation: "marquee-x ".concat(speed, "s linear infinite")
    }
  }, seg, seg, seg, seg));
}

// ---- HoverImage (product card image w/ second-image swap) ------------------
function HoverImage(_ref7) {
  var src = _ref7.src,
    alt = _ref7.alt,
    src2 = _ref7.src2,
    _ref7$ratio = _ref7.ratio,
    ratio = _ref7$ratio === void 0 ? "1 / 1.2" : _ref7$ratio,
    hover = _ref7.hover,
    _ref7$scrim = _ref7.scrim,
    scrim = _ref7$scrim === void 0 ? true : _ref7$scrim,
    children = _ref7.children,
    style = _ref7.style,
    onClick = _ref7.onClick;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    style: _objectSpread({
      position: "relative",
      aspectRatio: ratio,
      background: "var(--bone-2)",
      overflow: "hidden",
      cursor: onClick ? "pointer" : "default"
    }, style)
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    style: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      opacity: hover && src2 ? 0 : 1,
      transition: "opacity 400ms var(--ease-out), transform 600ms var(--ease-out)",
      transform: hover && !src2 ? "scale(1.03)" : "scale(1)"
    }
  }), src2 && /*#__PURE__*/React.createElement("img", {
    src: src2,
    alt: "",
    "aria-hidden": "true",
    style: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      opacity: hover ? 1 : 0,
      transition: "opacity 400ms var(--ease-out)"
    }
  }), scrim && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(180deg, transparent 65%, rgba(0,0,0,0.18) 100%)",
      pointerEvents: "none",
      opacity: hover ? 1 : 0,
      transition: "opacity 240ms"
    }
  }), children);
}

// ---- Wordmark (logo) -------------------------------------------------------
function Wordmark(_ref8) {
  var _ref8$height = _ref8.height,
    height = _ref8$height === void 0 ? 36 : _ref8$height,
    _ref8$color = _ref8.color,
    color = _ref8$color === void 0 ? "ink" : _ref8$color;
  // Black hand-lettered script on bone — refined and editorial.
  // Pass color="color" for the rainbow version (used on dark surfaces).
  var src = color === "color" ? window.RR_ASSETS ? window.RR_ASSETS["logo-color"] : "assets/logo-color.png" : window.RR_ASSETS ? window.RR_ASSETS["logo-black"] : "assets/logo-black.png";
  return /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "Rebels & Rights",
    style: {
      height: height,
      display: "block"
    }
  });
}
/* ── swatch(colorName) → CSS background string ─────────────────────────── */
var SWATCH_MAP = {
  /* ── Neutral ─────────────────────────── */
  "Black":              "#111111",
  "Black Heather":      "#1a1a1a",
  "Oxblood Black":      "#1a0a0a",
  "Asphalt":            "#3a3a3a",
  "Charcoal":           "#4a4a4a",
  "Dark Heather":       "#3e3c3d",
  "Dark Grey Heather":  "#3e3c3d",
  "Heather Dark Grey":  "#3e3c3d",
  "White":              "#FFFFFF",
  "Solid White Blend":  "#f5f5f0",
  "Vintage White":      "#f0ead8",
  "Soft Cream":         "#f5edd4",
  "Natural":            "#e8dcc8",
  "Heather Natural":    "#ddd4bc",
  "Heather Prism Natural": "#ddd4bc",
  "Ash":                "#c8c4bc",
  "Athletic Heather":   "#b2b7be",
  "Silver":             "#b8bcc4",
  "Ice Grey":           "#d8dce0",
  "Sport Grey":         "#9a9ea6",
  "Heather Grey":       "#9a978e",
  "Heather Stone":      "#8e8880",
  "Pebble":             "#aea190",
  "Heather Dust":       "#c4b09a",
  /* ── Blue / Navy ─────────────────────── */
  "Navy":               "#1b2a4a",
  "Midnight Navy":      "#1d242e",
  "Heather Navy":       "#303643",
  "Royal Navy":         "#274c97",
  "Royal":              "#3a5daa",
  "Heather Blue Lagoon":"#4a7a9b",
  "Heather Ice Blue":   "#a8c8d8",
  "Heather Prism Ice Blue": "#b4d0de",
  "Baby Blue":          "#aac8e0",
  "Indigo Blue":        "#3d3d7a",
  "Steel Blue":         "#4a6b8a",
  /* ── Green ───────────────────────────── */
  "Forest Green":       "#2d4a2b",
  "Heather Forest":     "#435140",
  "Military Green":     "#4a5240",
  "Army":               "#4b5320",
  "Heather Olive":      "#788453",
  "Moss":               "#6b7355",
  "Moss/ Khaki":        "#6b7355",
  "Khaki":              "#6b7355",
  "Sage":               "#8dab87",
  "Leaf":               "#4a7a4a",
  "Mint":               "#88c8a8",
  "Safety Green":       "#b8e020",
  /* ── Red / Pink / Berry ──────────────── */
  "Red":                "#cc2200",
  "Cardinal":           "#8b1a1a",
  "Maroon":             "#6b1a2a",
  "Heather Red":        "#aa3333",
  "Poppy":              "#e03030",
  "Berry":              "#8b2252",
  "Light Pink":         "#f4a8b8",
  "Pink":               "#f07898",
  "Soft Pink":          "#f0a8bc",
  "Azalea":             "#e87898",
  /* ── Yellow / Orange / Gold ──────────── */
  "Yellow":             "#f5c842",
  "Gold":               "#d4a017",
  "Citron":             "#b8c820",
  "Sand":               "#c8a878",
  "Texas Orange":       "#cc5500",
  "Safety Orange":      "#e85500",
  "Sunset":             "#e87040",
  /* ── Purple / Teal / Other ───────────── */
  "Purple":             "#5a2d82",
  "Team Purple":        "#7B4EA4",
  "Heather Purple":     "#7a4a9a",
  "Heather Prism Purple": "#9a6ab8",
  "Heather Mauve":      "#B8899E",
  "Mauve":              "#B08090",
  "Heather Orchid":     "#C88AAE",
  "Slate":              "#708090",
  "Heather Slate":      "#4d626f",
  "Storm":              "#6E7F8D",
  "Heather Storm":      "#6E7F8D",
  "Heather Deep Teal":  "#2a5a58",
  "Teal":               "#2A8080",
  "Dark Chocolate":     "#3d1f13",
  "Brown":              "#6B4226",
  "Russet":             "#7a3a1a",
  "Paragon":            "#2a4a5a",
  "Heather Military Green": "#6B7A54",
  "Heather Prism Lilac":"#b8a0c8",
  "Lavender":           "#9B8CC8",
  "Heather Lavender":   "#9B8CC8",
  "Heather Aqua":       "#5AAAB8",
  "Aqua":               "#4AB8C4",
  "Rainbow":            "linear-gradient(135deg,#e03030,#e07030,#d4a017,#4a7a4a,#3a5daa,#5a2d82)",
  /* ── Comfort Colors / specialty ──────── */
  "Ivory":              "#F5F0DC",
  "Butter":             "#F5E87C",
  "Peach":              "#F5A87C",
  "Melon":              "#F07878",
  "Watermelon":         "#E05060",
  "Crunchberry":        "#C84870",
  "Violet":             "#7850A8",
  "Cobalt":             "#3050A8",
  "True Navy":          "#1A2848",
  "Default Title":      "#CCCCCC",
  /* ── Heather Prism variants ──────────── */
  "Heather Prism Mint":   "#70c8a0",
  "Heather Prism Peach":  "#f0a888",
  "Heather Prism Dusty Blue": "#88a8c0",
};

function swatch(colorName) {
  if (!colorName) return "#cccccc";
  var exact = SWATCH_MAP[colorName];
  if (exact) return exact;
  /* fuzzy: check if any key is contained in the name or vice versa */
  var lower = colorName.toLowerCase();
  for (var k in SWATCH_MAP) {
    if (lower.includes(k.toLowerCase()) || k.toLowerCase().includes(lower)) {
      return SWATCH_MAP[k];
    }
  }
  return "#cccccc";
}

Object.assign(window, {
  Button: Button,
  Pill: Pill,
  Eyebrow: Eyebrow,
  Icon: Icon,
  SectionHead: SectionHead,
  Marquee: Marquee,
  HoverImage: HoverImage,
  Wordmark: Wordmark,
  swatch: swatch
});
